import React, { FC, useCallback } from 'react';
import { openModifierModal } from 'data/cacheHelpers/menu';

import Placeholder from 'components/Placeholders/MenuManagement';
import Loader from 'components/Loaders/MenuManagementModifierSets';
import { Container, Header, Caption, Modifier, Footer, Button } from './styles';
import { Props } from './types';

const ModifierSets: FC<Props> = ({
  isLoading,
  brandId,
  modifierGroups,
  isProcessing,
}) => {
  const modifiers = Object.keys(modifierGroups);

  const openNewModifierField = useCallback(
    () => openModifierModal({ brandId, modifier: {} }),
    [brandId],
  );

  if (isLoading) {
    return (
      <Container>
        <Header>
          <Caption>Name</Caption>
          <Caption>Type</Caption>
          <Caption>Selection</Caption>
          <Caption>Modifiers</Caption>
          <Caption>Used in</Caption>
        </Header>
        <Loader opacity={1} />
        <Loader opacity={0.75} />
        <Loader opacity={0.5} />
        <Loader opacity={0.25} />
        <Loader opacity={0} />
      </Container>
    );
  }

  if (modifiers.length > 0) {
    return (
      <Container>
        <Header>
          <Caption>Name</Caption>
          <Caption>Type</Caption>
          <Caption>Selection</Caption>
          <Caption>Modifiers</Caption>
          <Caption>Used in</Caption>
        </Header>

        {modifiers.map((modifierGroupId) => (
          <Modifier
            key={modifierGroupId}
            brandId={brandId}
            modifier={modifierGroups[modifierGroupId]}
          />
        ))}

        <Footer>
          <Button
            size="small"
            type="button"
            onClick={openNewModifierField}
            disabled={isProcessing}
          >
            Add modifier set
          </Button>
        </Footer>
      </Container>
    );
  }

  return (
    <Placeholder
      message={`You don't have any modifier set`}
      buttonCaption="Add modifier set"
      disabled={isProcessing}
      onClick={openNewModifierField}
    />
  );
};

export default ModifierSets;
